import React from 'react';
import { Loader2 } from 'lucide-react';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-[--c-dark] mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-[--c-main]">Loading</h2>
        <div className="mt-2 text-indigo-100 text-sm">Please wait while we prepare your experience</div>
      </div>
    </div>
  );
}

export default App;